<template>
  <div class="section">
    <div class="container">
      <h1>Supporting documents <span v-show="downloading"><i class="far fa-spinner-third fa-spin"></i></span></h1>
      <div class="columns">
        <div class="column is-5">
          <b-input v-model="filter" placeholder="Filter Documents"></b-input>
        </div>
        <div class="column is-7">
          <b-button v-if="$store.getters['isAdmin']" class="is-primary is-pulled-right" @click="openAddDocument">Add Supporting Document</b-button>
        </div>
      </div>
      <br />
      <b-table :data="filterDocuments"
               :hoverable="true"
               :loading="isLoading"
               :mobile-cards="true"
               :paginated="true"
               :per-page="10"
               :pagination-simple="true"
               default-sort-direction="desc"
               default-sort="Uploaded">
        <b-table-column field="Title" label="Title" sortable v-slot="props">
          <div v-if="$store.getters['canDownloadSupporting']">
            <a @click="downloadDocument(props.row.S3Name, props.row.Title)">{{ props.row.Title }}</a>
          </div>
          <div v-if="!$store.getters['canDownloadSupporting']" sortable>
            {{ props.row.Title }}
          </div>
        </b-table-column>
        <b-table-column field="Access" label="Audience" sortable v-slot="props">
          <div v-if="props.row.Access == 'Member'">{{ props.row.CountryName }}</div>
          <div v-if="!(props.row.Access == 'Member')">{{ props.row.Access }}</div>
        </b-table-column>
        <b-table-column field="Uploaded" label="Uploaded" sortable v-slot="props">
          {{ props.row.Uploaded | utc | moment('M/DD/YYYY') }}
        </b-table-column>
        <b-table-column v-if="$store.getters['isAdmin']" label="Delete" width="30" v-slot="props">
          <div style="cursor: pointer;" @click="deleteDocument(props.row.S3Name)">
            <i class="fad fa-trash-alt"></i>
          </div>
        </b-table-column>
      </b-table>
    </div>
  </div>
</template>

<script>
  import addDocument from "@/components/modals/addDocument.vue";
  export default {
    data() {
      return {
        filter: '',
        countries: [],
        documents: [],
        isLoading: false,
        downloading: false
      }
    },
    computed: {
      filterDocuments() {
        return this.documents.filter((option) => {
          if (option.Title && (option.Title.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0)) {
            return option
              .Title
              .toString()
              .toLowerCase()
              .indexOf(this.filter.toLowerCase()) >= 0;
          } else if (option.CountryName && (option.CountryName.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0)) {
            return option
              .CountryName
              .toString()
              .toLowerCase()
              .indexOf(this.filter.toLowerCase()) >= 0;
          } else if (option.Access && (option.Access.toString().toLowerCase().indexOf(this.filter.toLowerCase()) >= 0)) {
            return option
              .Access
              .toString()
              .toLowerCase()
              .indexOf(this.filter.toLowerCase()) >= 0;
          }
        });
      }
    },
    methods: {
      async downloadDocument(S3Name, Title) {
        this.downloading = true;
        var re = /(?:\.([^.]+))?$/;
        await this.$http({ method: 'get', url: 'api/document/' + S3Name, responseType: 'arraybuffer' })
          .then(resp => {
            let blob;

            if (re.exec(S3Name)[0].toLowerCase() == ".pdf") {
              blob = new Blob([resp.data], { 'type': 'application/pdf' });
            } else if (re.exec(S3Name)[0].toLowerCase() == ".doc") {
              blob = new Blob([resp.data], { 'type': 'application/msword' });
            } else if (re.exec(S3Name)[0].toLowerCase() == ".docx") {
              console.log("docx here")
              blob = new Blob([resp.data], { 'type': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
            }

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);

            if (re.exec(S3Name)[0].toLowerCase() == ".pdf") {
              link.setAttribute('download', Title + '.pdf');
            } else if (re.exec(S3Name)[0].toLowerCase() == ".doc") {
              link.setAttribute('download', Title + '.doc');
            } else if (re.exec(S3Name)[0].toLowerCase() == ".docx") {
              link.setAttribute('download', Title + '.docx');
            }

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.downloading = false;
          });
      },
      async deleteDocument(S3Name) {
        if (confirm("Are you sure you would like to delete this supporting document?")) {
          await this.$http.post("api/document/delete/" + S3Name)
            .then(async resp => {
              if (resp.data == "Successfully Deleted.") {
                this.$buefy.notification.open({
                  message: resp.data,
                  type: "is-success"
                })
              } else {
                this.$buefy.notification.open({
                  message: "Failed to delete document",
                  type: "is-danger"
                })
              }
              await this.getDocuments();
            })
        }
      },
      openAddDocument() {
        this.$buefy.modal.open({
          parent: this,
          component: addDocument,
          hasModalCard: true,
          props: {
            Countries: this.countries,
          },
          events: {
            addDocument: async (document) => {
              var formData = new FormData();
              formData.append('file', document.File);
              await this.$http.post("api/document", formData, { headers: { "Content-Type": 'multipart/form-data' } })
                .then(async resp => {
                  if (resp.data == "Document was not uploaded properly") {
                    this.$buefy.notification.open({
                      duration: 4000,
                      message: "An error occured. Please try again later.",
                      type: 'is-danger'
                    })
                  } else {
                    await this.$http.post("api/document/supporting", { Title: document.Title, Access: document.Access, CountryId: document.CountryId, S3Name: resp.data })
                      .then(async resp => {
                        if (resp.data) {
                          this.$buefy.notification.open({
                            duration: 4000,
                            message: "Document uploaded successfully",
                            type: 'is-success',
                          })
                          await this.getDocuments();
                        }
                      }).catch(err => {
                        console.error(err);
                      })

                  }
                }).catch(err => {
                  console.error(err);
                })
            }
          }
        })
      },
      getDocuments() {
        this.isLoading = true;
        //var userRoles = this.$store.getters["user"].Roles;
        this.$http.post("api/document/all")
          .then(resp => {
            this.documents = resp.data;
            this.isLoading = false;
          }).catch(err => {
            console.error(err);
            this.isLoading = false;
          })
      }
    },
    async created() {
      await this.getDocuments();

      await this.$http.get("api/document/countries")
        .then(resp => {
          this.countries = resp.data;
        }).catch(err => {
          console.error(err);
        })
    }
  }
</script>
